/**
 * Whatever quntity multiplier we have for listing that is shown in a separate row.
 * This is hard coded 1 for when main listing + order bump listings are added. and we show count for each iin payment summary.
 */
export const single_unit_value = 1;
